import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const addUserToAnonymousGroup = ({ groupId, urlSlug }) =>
  call(websocketFetch, 'add_user_to_anonymous_group', {
    group_id: groupId,
    url_slug: urlSlug,
  });
